export const guideTopics = [
  {
    id: "open",
    icon: "ri-link",
    label: "网站打不开",
    title: "笔笔漫画网打不开怎么办",
    intro:
      "访问笔笔漫画网时遇到页面空白、无法加载或提示域名出错，先别着急，多数情况通过下面几步就能恢复访问。",
    steps: [
      { title: "检查网络连接", text: "确认设备当前联网正常，可先打开其他网站测试。若使用公共 Wi-Fi，尝试切换到移动数据再访问一次。" },
      { title: "清理浏览器缓存", text: "浏览器缓存堆积可能造成页面异常，清除缓存与 Cookies 后刷新，或改用 Chrome、Edge 等常用浏览器访问。" },
      { title: "核对官方访问入口", text: "认准笔笔漫画网官方域名，避免通过非官方镜像或第三方链接进入，防止误入仿冒站点。" },
      { title: "切换备用访问线路", text: "网站首页提供多条访问线路，遇到入口不稳定时点击备用入口即可快速切换。" },
      { title: "联系客服协助排查", text: "若以上方法均无效，请通过页面底部联系方式反馈设备与网络情况，客服会协助进一步排查。" },
    ],
  },
  {
    id: "slow",
    icon: "ri-speed-line",
    label: "加载慢",
    title: "笔笔漫画网加载慢如何提速",
    intro:
      "漫画图片加载缓慢、翻页卡顿，通常与网络线路、缓存占用和设备状态有关，可按以下顺序逐项优化。",
    steps: [
      { title: "切换更快的阅读线路", text: "在阅读页或首页选择标注为“推荐/极速”的线路，通常能显著缩短图片加载时间。" },
      { title: "清理缓存与历史记录", text: "长时间使用会产生大量缓存文件，定期清理可释放空间、加快页面响应。" },
      { title: "关闭后台占用程序", text: "同时运行下载、视频等程序会抢占带宽，阅读时尽量关闭无关软件和后台进程。" },
      { title: "错峰浏览更顺畅", text: "晚间高峰时段流量较大，避开拥挤时段阅读能获得更稳定的加载体验。" },
      { title: "使用无痕模式测试", text: "若缓存清理后仍慢，可尝试无痕模式打开，排查是否为插件或扩展干扰所致。" },
    ],
  },
  {
    id: "source",
    icon: "ri-refresh-line",
    label: "换源",
    title: "笔笔漫画网换源操作指南",
    intro:
      "同一部漫画有时会出现清晰度、更新速度不一致的情况，使用“换源”功能即可切换到更合适的资源源。",
    steps: [
      { title: "进入漫画详情页", text: "打开目标漫画，进入详情页面后即可看到章节列表与相关操作按钮。" },
      { title: "点击换源按钮", text: "在详情页或阅读页点击“换源”，系统会列出当前可用的多个资源源。" },
      { title: "选择合适资源源", text: "根据清晰度、更新进度和加载速度，选中一个标记可用的源并确认切换。" },
      { title: "对比后固定常用源", text: "切换后可对比不同源的观感，把最稳定的源设为默认，下次阅读自动沿用。" },
      { title: "切换失败时手动刷新", text: "若切换后章节暂时缺失，等待片刻或手动刷新页面，多数情况会很快同步。" },
    ],
  },
  {
    id: "favorite",
    icon: "ri-heart-3-line",
    label: "收藏",
    title: "笔笔漫画网收藏功能说明",
    intro:
      "把追更的漫画加入收藏，就能在“我的收藏”里集中管理，还能多设备同步阅读进度，追更不再迷路。",
    steps: [
      { title: "登录账号后使用", text: "收藏功能需要登录账号，未登录时点击收藏会提示先完成登录。" },
      { title: "点击收藏图标", text: "在漫画详情页点击心形收藏图标，即可将漫画加入你的收藏夹。" },
      { title: "在“我的收藏”集中查看", text: "进入个人中心的“我的收藏”，可查看全部已收藏漫画并按最近更新排序。" },
      { title: "支持分类与排序", text: "可为收藏添加分组标签，按更新时间、热度或手动顺序整理你的追更列表。" },
      { title: "多设备自动同步", text: "登录同一账号后，收藏列表和阅读进度会在不同设备间自动同步。" },
    ],
  },
  {
    id: "search",
    icon: "ri-search-line",
    label: "搜索",
    title: "笔笔漫画网搜索使用技巧",
    intro:
      "想快速找到想看的漫画，用好搜索功能很关键。支持按名称、作者和标签等多种方式精确查找。",
    steps: [
      { title: "使用顶部搜索框", text: "在页面顶部搜索框输入漫画名称或关键词，回车即可检索全站资源。" },
      { title: "支持多维度搜索", text: "除了漫画名，还可以按作者、题材标签、连载状态等进行组合搜索。" },
      { title: "善用筛选与排序", text: "搜索结果页支持按人气、更新时间、评分筛选排序，快速定位目标作品。" },
      { title: "查看历史搜索", text: "搜索框会记录最近查询，方便你快速重复查找常看的作品。" },
      { title: "搜索不到时换词试试", text: "若结果为空，可尝试替换同义词或简写，并切换不同资源源再次搜索。" },
    ],
  },
  {
    id: "login",
    icon: "ri-user-3-line",
    label: "登录",
    title: "笔笔漫画网登录与账号说明",
    intro:
      "登录账号后即可同步收藏、阅读记录和追更状态。注册登录都很简单，忘记密码也能快速找回。",
    steps: [
      { title: "找到登录入口", text: "点击页面右上角“登录”按钮，进入登录界面，可使用手机号或邮箱登录。" },
      { title: "新用户注册", text: "没有账号时点击“注册”，按提示填写信息并完成验证即可创建账号。" },
      { title: "忘记密码怎么办", text: "在登录页点击“忘记密码”，通过绑定手机号或邮箱验证后即可重置新密码。" },
      { title: "登录后的专属功能", text: "登录后可同步收藏、阅读记录，并参与评论、追更提醒等互动功能。" },
      { title: "第三方账号绑定", text: "支持绑定常用第三方账号，绑定后即可一键快捷登录，省去重复输入。" },
    ],
  },
];

export const faqItems = [
  {
    q: "笔笔漫画网需要付费吗？",
    a: "笔笔漫画网提供大量免费漫画资源，基础阅读功能完全免费。部分高级功能（如极速线路、去广告）可能会单独提示，是否使用由你决定，不会强制收费。",
  },
  {
    q: "为什么手机端和电脑端的收藏记录不一样？",
    a: "收藏和阅读进度需要在同一账号登录后才能同步。请确认手机端和电脑端都使用同一个账号登录，若仍不同步，可尝试退出后重新登录一次。",
  },
  {
    q: "换源之后，为什么漫画章节变少了？",
    a: "不同资源源的上传进度和集数可能不一致。建议切换后稍等片刻刷新，或对比多个源选择更新最完整的一个，章节数据通常会自动对齐。",
  },
  {
    q: "收藏的漫画可以导出或分享吗？",
    a: "目前支持将单部漫画以链接形式分享给好友，暂不支持批量导出收藏列表。我们正在评估批量管理功能，后续版本会持续完善。",
  },
  {
    q: "搜索不到想看的漫画怎么办？",
    a: "可以先尝试更换关键词或使用作者名搜索，同时切换不同资源源。如果仍然找不到，欢迎通过页面底部联系方式提交作品名，我们会反馈并尽力收录。",
  },
  {
    q: "遇到章节错误或图片缺失如何反馈？",
    a: "在漫画详情页或阅读页点击“反馈/报错”，选择对应章节并说明问题即可提交。提交后我们会尽快核查，你也可以在联系表单中补充更多信息。",
  },
  {
    q: "在其他设备登录我的账号安全吗？",
    a: "请在可信设备上登录，避免使用公共设备保存账号信息。如怀疑账号异常，可在个人中心修改密码并退出其他设备登录。",
  },
  {
    q: "页面出现弹窗或广告怎么办？",
    a: "请优先确认使用的是官方域名和推荐线路。若仍频繁遇到弹窗，可清理浏览器缓存并关闭可疑插件，必要时通过联系表单反馈具体入口。",
  },
];

export const testimonials = [
  {
    name: "追漫的小鹿",
    role: "追更三年 · 国漫读者",
    text: "换源功能真的救了我，遇到更新慢的源一键就切到更快的，追的几部国漫再也没断更过。",
  },
  {
    name: "晨星",
    role: "热血番爱好者",
    text: "收藏和阅读进度能同步到手机，通勤路上接着看太方便了，收藏夹整理得明明白白。",
  },
  {
    name: "阿橙",
    role: "日漫老粉",
    text: "搜索很顺手，按作者找冷门作品一搜就到，加载慢的问题按指南换条线路就好了。",
  },
  {
    name: "青柠气泡水",
    role: "新晋漫画迷",
    text: "第一次遇到打不开还以为是网站出问题了，照着打不开指南几步就恢复了，客服回复也很快。",
  },
];

export const newcomerSteps = [
  { icon: "ri-user-add-line", title: "注册账号", text: "用手机号或邮箱注册并登录，即可开启追更之旅。" },
  { icon: "ri-search-line", title: "搜索目标", text: "通过搜索框按名称、作者或标签找到想看的漫画。" },
  { icon: "ri-heart-3-line", title: "加入收藏", text: "一键收藏并分组整理，追更进度自动保存。" },
  { icon: "ri-book-open-line", title: "顺畅阅读", text: "按需切换线路或换源，享受流畅稳定的阅读体验。" },
];